import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=5edbe172"
import script from "./Admin.vue?vue&type=script&setup=true&lang=js"
export * from "./Admin.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Admin.vue?vue&type=style&index=0&id=5edbe172&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports